module.exports = __webpack_public_path__ + "img/ywc.f0e330a5.png";